var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCognition = function SvgIconCognition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 22.01v-6.3a9 9 0 1 0-15-6.7v1l-2 4 2 1v3a2 2 0 0 0 2 2h4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 9.009,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.009v-2m2.121 2.879 1.415-1.415M14 9.009h2m-2.879 2.121 1.415 1.415M11 12.009v2M8.879 11.13l-1.415 1.415M8 9.009H6m2.879-2.121L7.464 5.473"
  })))));
};
export { SvgIconCognition as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMSkiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTcgMjIuMDF2LTYuM2E5IDkgMCAxIDAtMTUtNi43djFsLTIgNCAyIDF2M2EyIDIgMCAwIDAgMiAyaDR2MiIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxMSIgY3k9IjkuMDA5IiByPSIzIi8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMSA2LjAwOXYtMk0xMy4xMjEgNi44ODhsMS40MTUtMS40MTVNMTQgOS4wMDloMk0xMy4xMjEgMTEuMTNsMS40MTUgMS40MTVNMTEgMTIuMDA5djJNOC44NzkgMTEuMTNsLTEuNDE1IDEuNDE1TTggOS4wMDlINk04Ljg3OSA2Ljg4OCA3LjQ2NCA1LjQ3MyIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";